import { getCookie } from './auth'

export function parseJwt () {
  const token = getCookie('token')
  const base64Url = token.split('.')[1]
  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
  const jsonPayload = decodeURIComponent(atob(base64).split('').map(function (c) {
    return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
  }).join(''))
  return JSON.parse(jsonPayload)
}

export function getName () {
  const parsedJWT = parseJwt()
  return parsedJWT.ad_soyad
}

export function getMail () {
  const parsedJWT = parseJwt()
  return parsedJWT.eposta
}

export function getRole () {
  const parsedJWT = parseJwt()
  return parsedJWT.yetki
}

export function getID () {
  const parsedJWT = parseJwt()
  return parsedJWT.kisi_id
}

export function getIl () {
  const parsedJWT = parseJwt()
  return parsedJWT.il_id
}

export function getBolge () {
  const parsedJWT = parseJwt()
  return parsedJWT.bolge_id
}

export function getIlce () {
  const parsedJWT = parseJwt()
  return parsedJWT.ilce_id
}

export function getUlke () {
  const parsedJWT = parseJwt()
  return parsedJWT.ulke_id
}

export function getCinsiyet () {
  const parsedJWT = parseJwt()
  return parsedJWT.cinsiyet
}
